import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routesOperator.js";

import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/reactlogo.png";
import bgImage2 from "assets/img/sidebar-7.jpeg";
import bgImage3 from "assets/img/sidebar-6.jpeg";
import bgImage4 from "assets/img/sidebar-9.jpeg";
import bgImage5 from "assets/img/sidebar-10.jpeg";
import useAuth from "hooks/useAuth";

let ps;

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      return (
        <Route
          path={(prop.layout || '') + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/operator" to="/operator/dashboard" />
    <Redirect from="/material-dashboard-react" to="/operator/dashboard" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Operator({ ...rest }) {
  // styles
  const classes = useStyles();
  const { storageId, garlicType } = useAuth();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  const mainPanelGarlic = React.createRef();

  // states and functions
  let image = bgImage; // aqui que se muda a imagem de trás
  let color = "red";
  if (storageId === 1 || storageId === 2) {
    image = bgImage4;
    color = 'blue'
  } if (storageId === 3) {
    image = bgImage2;
  }
  if (storageId === 4) {
    image = bgImage5;
  }
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/operator/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      if (garlicType === true) {
        ps = new PerfectScrollbar(mainPanelGarlic.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
      } else {
        ps = new PerfectScrollbar(mainPanel.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
      }
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={""}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={garlicType === true ? classes.mainPanelGarlic : classes.mainPanel} ref={garlicType === true ? mainPanelGarlic : mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}
